//Toast manager for session expiry and other relevant messages
let toastCallback = null;

export function setToastCallback(callback) {
  toastCallback = callback;
}

export function showToast(message, type = "info") {
  if (toastCallback) {
    toastCallback(message, type);
  } else {
  }
}
